import { render } from "./BootstrapAlert.vue?vue&type=template&id=e7549284&scoped=true"
import script from "./BootstrapAlert.vue?vue&type=script&lang=js"
export * from "./BootstrapAlert.vue?vue&type=script&lang=js"

import "./BootstrapAlert.vue?vue&type=style&index=0&id=e7549284&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7549284"],['__file',"src/components/BootstrapAlert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e7549284"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e7549284', __exports__)) {
    api.reload('e7549284', __exports__)
  }
  
  module.hot.accept("./BootstrapAlert.vue?vue&type=template&id=e7549284&scoped=true", () => {
    api.rerender('e7549284', render)
  })

}


export default __exports__